import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-canvas py-10 px-4 sm:px-6 lg:px-8">
      <article className="max-w-3xl mx-auto bg-surface rounded-lg shadow-sm border border-edge p-6 sm:p-10">
        <h1 className="text-3xl font-bold text-ink mb-2">{t('privacyPage.title')}</h1>
        <p className="text-sm text-ink-subtle mb-8">{t('privacyPage.lastUpdated')}</p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-ink mb-3">{t('privacyPage.section1Title')}</h2>
          <p className="text-ink-muted leading-relaxed whitespace-pre-line">{t('privacyPage.section1Body')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-ink mb-3">{t('privacyPage.section2Title')}</h2>
          <p className="text-ink-muted leading-relaxed whitespace-pre-line">{t('privacyPage.section2Body')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-ink mb-3">{t('privacyPage.section3Title')}</h2>
          <p className="text-ink-muted leading-relaxed whitespace-pre-line">{t('privacyPage.section3Body')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-ink mb-3">{t('privacyPage.section4Title')}</h2>
          <p className="text-ink-muted leading-relaxed whitespace-pre-line">{t('privacyPage.section4Body')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-ink mb-3">{t('privacyPage.section5Title')}</h2>
          <p className="text-ink-muted leading-relaxed whitespace-pre-line">{t('privacyPage.section5Body')}</p>
        </section>

        <p className="text-ink-muted leading-relaxed mb-8">
          {t('privacyPage.contactLine')}{' '}
          <a href="mailto:info4edvise@gmail.com" className="text-link hover:text-link-hover underline">
            info4edvise@gmail.com
          </a>
          {t('privacyPage.contactLineEnd')}
        </p>

        <Link
          to="/"
          className="inline-flex text-link hover:text-link-hover font-medium"
        >
          {t('privacyPage.backToHome')}
        </Link>
      </article>
    </div>
  );
};

export default Privacy;
